//-----------------Localhost------------------------------//
// const apiUrl = "http://localhost:8104/";
// const tokenUrl = "http://localhost:7115/";
// const envCode = "Local";

//-----------------187.127.131.218------------------------------//
// const apiUrl = "https://187.127.131.218:7114/";
// const tokenUrl = "https://187.127.131.218:7115/";
// const envCode = "Testing";

//-----------------31.97.232.83------------------------------//
const apiUrl = "https://parivikshak.in/api/";
const tokenUrl = "https://parivikshak.in/apix/";
const envCode = "Prod";

const notificationUrl =
  "https://ind.parivikshak.co.in/dashboard/admin/notification.php";

const getMimeTypeFromExtension = (filename) => {
  const ext = filename.split(".").pop().toLowerCase();
  switch (ext) {
    case "jpg":
    case "jpeg":
      return "image/jpeg";
    case "png":
      return "image/png";
    case "gif":
      return "image/gif";
    case "webp":
      return "image/webp";
    case "bmp":
      return "image/bmp";
    case "svg":
      return "image/svg+xml";

    case "pdf":
      return "application/pdf";
    case "doc":
      return "application/msword";
    case "docx":
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    case "xls":
      return "application/vnd.ms-excel";
    case "xlsx":
      return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    case "ppt":
      return "application/vnd.ms-powerpoint";
    case "pptx":
      return "application/vnd.openxmlformats-officedocument.presentationml.presentation";
    case "txt":
      return "text/plain";

    default:
      return "application/octet-stream"; // fallback
  }
};

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB
const ALLOWED_TYPES = [
  "image/jpeg",
  "image/png",
  "image/jpg",
  "image/webp",
  "application/pdf",
];

export {
  apiUrl,
  tokenUrl,
  notificationUrl,
  envCode,
  MAX_FILE_SIZE,
  ALLOWED_TYPES,
  getMimeTypeFromExtension,
};
